module.exports = __webpack_public_path__ + "img/whats-new-12_jp.618e1f8.jpg";